import { LoginForm } from "./-LoginForm";

export function LoginPage() {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-slate-50 px-4 py-12 sm:px-6 lg:px-8">
      <div className="absolute -left-24 -top-24 h-96 w-96 rounded-full bg-indigo-300/40 mix-blend-multiply blur-[100px]" />
      <div className="absolute -right-24 top-1/4 h-96 w-96 rounded-full bg-fuchsia-300/30 mix-blend-multiply blur-[100px]" />
      <div className="absolute -bottom-24 left-1/3 h-96 w-96 rounded-full bg-cyan-300/30 mix-blend-multiply blur-[100px]" />

      <div className="relative w-full max-w-md rounded-[2rem] bg-white/70 px-8 py-12 shadow-[0_8px_30px_rgb(0,0,0,0.04)] backdrop-blur-xl border border-white">
        <div className="mb-10 text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-tr from-indigo-500 to-fuchsia-500 shadow-lg shadow-indigo-500/30 text-white">
            <svg
              aria-hidden="true"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
              />
            </svg>
          </div>
          <h1 className="mt-6 text-3xl font-extrabold tracking-tight text-gray-900">Media House</h1>
          <p className="mt-2 text-sm text-gray-500">Admin access only</p>
        </div>
        <LoginForm />
      </div>
    </div>
  );
}
